import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import SideNav from './sidenav';
import Navbar from './navbar';
import { Outlet } from 'react-router-dom';
import Login from '../../pages/Login';
import AutoRedirectToAzureB2C from '../Login/AutoLoginAzureAd';
import { useState } from 'react';
import { isSidebarCollapsedAtom } from '../../atoms/sidebar';
import { useAtom } from 'jotai';

export const PageLayout = () => {
  const [isCollapsed, setIsCollapsed] = useAtom(isSidebarCollapsedAtom);

  const handleCollapsed = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      <AuthenticatedTemplate>
        <div className="flex flex-row min-h-screen bg-[#F4F4F4]">
          <div
            className={
              isCollapsed
                ? 'w-[100px] rounded-md bg-[#FCFCFC] fixed h-full z-10'
                : 'basis-1/6  fixed h-full z-10'
            }
          >
            <SideNav handleCollapseOfParent={handleCollapsed} />
          </div>
          <div
            className={`flex-1 flex flex-col ${isCollapsed ? 'ml-[100px]' : 'ml-[16.666667%]'}`}
          >
            <div
              className="fixed top-0 right-0 left-auto z-20 bg-white shadow-sm"
              style={{
                width: `calc(100% - ${isCollapsed ? '100px' : '12.666667%'})`,
              }}
            >
              <Navbar isCollapsed={isCollapsed} />
            </div>
            <div className="pt-16 bg-[#F4F4F4] min-h-screen">
              <div className="mt-4 mx-4 rounded-2xl bg-[#F4F4F4]">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {/* <Login/> */}
        <AutoRedirectToAzureB2C />
      </UnauthenticatedTemplate>
    </>
  );
};
